import { acceptHMRUpdate, defineStore } from 'pinia'

// all in one file for now, will be split into multiple files later if necessary
export const useDistanceStore = defineStore('distance', () => {
  const { locale, n, numberFormats } = useI18n()

  // actions
  function convertMilesToKilometers(miles: number): number {
    return miles * 1.60934
  }

  function formatDistance(distanceInMiles: number): string {
    if (!distanceInMiles) {
      return ''
    }

    const currentLocale = locale.value
    const unit =
      numberFormats.value[currentLocale]?.distance?.unit ??
      numberFormats.value[currentLocale.substring(0, 2)]?.distance?.unit ??
      'mile'

    let distance = distanceInMiles
    if (unit === 'kilometer') {
      distance = convertMilesToKilometers(distanceInMiles)
    }

    const formattedDistance = Number(distance % 1 === 0 ? distance.toFixed(0) : distance.toFixed(1))

    return n(formattedDistance, 'distance')
  }

  return {
    // actions
    convertMilesToKilometers,
    formatDistance
  }
})

// adds HMR for pinia
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDistanceStore, import.meta.hot))
}
